export default "__VITE_ASSET__DQP_BH8H__"